<template>
	<v-dialog
		v-model="visible"
		max-width="500"
		persistent
	>
		<v-alert
			class="mb-0 px-8"
			:border="'top'"
			colored-border
			:color="color"
		>
			<v-row class="mt-0">
				<div class="title-text">{{ titleText }}</div>
			</v-row>
			<v-row>
				<div class="content-text">
					This will change the claim to Draft status and return it to the originating user<span v-if="userName.length !== 0" class="content-name"> {{ userName }}</span>. Are you sure?
				</div>
			</v-row>
			<v-row>
				<v-textarea
					outlined
					hide-details
					v-model="reason"
					:color="textColor"
				></v-textarea>
			</v-row>
			<v-row justify="end">
				<div class="required-text">required</div>
			</v-row>
			<v-row v-if="userName.length !== 0" class="mt-0">
				<div>Send to <span class="content-name">{{ userName }}</span></div>
			</v-row>
			<v-row justify="center" class="mb-0">
				<v-btn width="88" outlined color="rgba(25, 42, 62, 0.7)" class="text-capitalize" @click="$emit('cancel')">{{ cancel_button }}</v-btn>
				<v-btn 
					width="88"
					depressed 
					:color="reason.length > 0 ? '#F45252': 'rgba(25, 42, 62, 0.15)'" 
					class="ml-3 text-capitalize white--text" 
					@click="$emit('ok', reason)">
					<v-icon class="mr-1">mdi-check</v-icon>
					{{ confirm_button }}
				</v-btn>
			</v-row>
		</v-alert>
	</v-dialog>
</template>
<script>
export default {
	name: 'RecoverDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: '#F45252'
		},
		textColor: {
			type: String,
			default: ''
		},
		titleText: {
			type: String,
			default: ''
		},
		userName: {
			type: String,
			default: ''
		},
		confirm_button: {
			type: String,
			default: 'OK'
		},
		cancel_button: {
			type: String,
			default: 'Cancel'
		},
	},
	data() {
		return {
			reason: ''
		}
	}
}
</script>
<style lang="scss" scoped>
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.content-text {
  font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	color: #37495F;
}
.content-name {
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: #192A3E;
}
.required-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;
	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
</style>